import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarVisible: true,
    sidebarUnfoldable: true,
    page: '',
    userId: '',
    email: '',
    subscribed: false,
    isMobileOpen: false,
    isSidenavOpen: true,
    showSidenav: true,
    selectedModel: '',
    selectedSize: '',
    imageCount: 1,
    initChatBot: '',
    isProcessing: false,
    triggerPolling: true,
    conversationStatus: null,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload
    },
    updatePage(state, payload) {
      state.page = payload
    },
    updateUserId(state, payload) {
      state.userId = payload
    },
    updateEmail(state, payload) {
      state.email = payload
    },
    updateSubscribed(state, payload) {
      state.subscribed = payload
    },
    setMobileState(state, payload) {
      state.isMobileOpen = payload
    },
    setSidenavState(state, payload) {
      state.isSidenavOpen = payload
    },
    updateSelectedModel(state, payload) {
      state.selectedModel = payload
    },
    updateSelectedSize(state, payload) {
      state.selectedSize = payload
    },
    updateImageCount(state, payload) {
      state.imageCount = payload
    },
    updateInitChatBot(state, payload) {
      state.initChatBot = payload
    },
    updateProcessing(state, payload) {
      state.isProcessing = payload
    },
    updateTriggerPolling(state, payload) {
      state.triggerPolling = payload
    },
    updateConversationStatus(state, payload) {
      state.conversationStatus = payload
    },
  },
  actions: {},
  modules: {},
})
